/* =========================================================
   GIORDANO CANADA - CART DRAWER "MORE PICKS FOR YOU BELOW" CUE (v1.1)
   Minimog 4.0.0 · loaded from snippets/cart-drawer.liquid

   A small black pill above the drawer footer, shown ONLY when the
   "Add a little extra" / "Complete your look" card is hidden below
   the visible part of the drawer (phones, small laptops, in-app
   browsers). Tap = smooth scroll to the card.

   Shown once per visit: as soon as the shopper taps it OR scrolls the
   card into view themselves, it is remembered (sessionStorage) and
   never shown again in that visit, even after the cart changes.
   A card that simply fits on screen hides the cue but is not "seen".

   Never shown when: the cart is empty, there is no upsell card, the
   card's Add button is already visible, the drawer is closed, or the
   Note popup is open.
   Survives Minimog re-rendering the drawer body after every cart change
   (the pill lives in the footer, which Minimog does not replace).
   ========================================================= */
(function () {
  "use strict";

  if (window.__gdScrollCueLoaded) return;
  window.__gdScrollCueLoaded = true;

  var KEY = "gd_cart_cue_seen";
  var SEEN_RATIO = 0.9; /* the card's Add button (almost) fully on screen = "seen" */
  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");

  var seenInMemory = false; /* fallback when sessionStorage is blocked (private mode, in-app browsers) */
  function seen() {
    if (seenInMemory) return true;
    try { return window.sessionStorage.getItem(KEY) === "1"; } catch (e) { return false; }
  }
  function markSeen() {
    seenInMemory = true;
    try { window.sessionStorage.setItem(KEY, "1"); } catch (e) {}
    hide();
  }

  function drawer() { return document.querySelector("m-cart-drawer"); }
  function body() { return document.querySelector("m-cart-drawer [data-minimog-cart-items]"); }
  function footer() { return document.getElementById("MinimogCartDrawerFooter"); }
  function isOpen() { var d = drawer(); return !!(d && d.classList.contains("m-cart-drawer--active")); }
  /* Note / shipping / coupon popup open in the footer: keep the cue out of the way */
  function popupOpen() { return !!document.querySelector("#MinimogCartDrawerFooter .m-cart-addon__body.open"); }

  /* The upsell card the shopper should notice (active panel) */
  function card() {
    var root = document.querySelector("m-cart-drawer .gca-cart-upsell:not([hidden])");
    if (!root) return null;
    return root.querySelector(".gca-cart-upsell__panel.is-active .gca-upsell-card") ||
      root.querySelector(".gca-upsell-card");
  }
  /* What must be on screen: the card's Add button (the card itself if none) */
  function target() {
    var c = card();
    if (!c) return null;
    return c.querySelector(".gca-upsell-card__add") || c;
  }

  var btn = null;
  function ensureButton() {
    var f = footer();
    if (!f) return null;
    if (btn && f.contains(btn)) return btn;
    btn = document.createElement("button");
    btn.type = "button";
    btn.className = "gd-scroll-cue";
    btn.setAttribute("aria-hidden", "true");
    btn.tabIndex = -1;
    btn.innerHTML =
      '<span data-gd-cue-label>More picks for you below</span>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    btn.addEventListener("click", function () {
      var t = card(), b = body();
      markSeen();
      if (!t || !b) return;
      var top = t.getBoundingClientRect().top - b.getBoundingClientRect().top + b.scrollTop - 12;
      b.scrollTo({ top: Math.max(0, top), behavior: REDUCED.matches ? "auto" : "smooth" });
    });
    f.insertBefore(btn, f.firstChild);
    return btn;
  }

  function show() {
    var b = ensureButton();
    if (!b) return;
    var mode = document.querySelector("m-cart-drawer .gca-cart-upsell[data-gca-mode]");
    var label = b.querySelector("[data-gd-cue-label]");
    var text = mode && mode.getAttribute("data-gca-mode") === "above" ? "Complete your look below" : "More picks for you below";
    if (label && label.textContent !== text) label.textContent = text;
    if (b.classList.contains("is-visible")) return;
    b.classList.add("is-visible");
    b.removeAttribute("aria-hidden");
    b.tabIndex = 0;
  }
  function hide() {
    if (!btn || !btn.classList.contains("is-visible")) return;
    btn.classList.remove("is-visible");
    btn.setAttribute("aria-hidden", "true");
    btn.tabIndex = -1;
  }

  /* Visible part of the card inside the scrolling body (0..1) */
  function visibleRatio(t, b) {
    var tr = t.getBoundingClientRect(), br = b.getBoundingClientRect();
    if (!tr.height) return 0;
    var top = Math.max(tr.top, br.top), bottom = Math.min(tr.bottom, br.bottom);
    return Math.max(0, bottom - top) / tr.height;
  }

  var raf = 0, byScroll = false;
  function update() {
    var fromScroll = byScroll;
    raf = 0; byScroll = false;
    if (seen() || !isOpen() || popupOpen()) { hide(); return; }
    var t = target(), b = body();
    if (!t || !b) { hide(); return; }
    var ratio = visibleRatio(t, b);
    if (ratio >= SEEN_RATIO) {
      /* Card on screen: no cue. It is remembered as "seen" only when the
         shopper scrolled to it themselves (or tapped the cue), so a card that
         happens to fit on a big screen never switches the cue off for good. */
      if (fromScroll) markSeen(); else hide();
      return;
    }
    show();
  }
  function schedule() {
    if (!raf) raf = requestAnimationFrame(update);
  }
  function onScroll() {
    byScroll = true;
    schedule();
  }

  /* --- wiring --- */
  var boundBody = null;
  function bindBody() {
    var b = body();
    if (!b || b === boundBody) return;
    boundBody = b;
    b.addEventListener("scroll", onScroll, { passive: true });
  }

  function init() {
    var d = drawer();
    if (!d) return;
    bindBody();
    ensureButton();

    /* Drawer open / close (class change) and body re-render (children replaced) */
    if ("MutationObserver" in window) {
      new MutationObserver(function () { setTimeout(schedule, 350); }).observe(d, { attributes: true, attributeFilter: ["class"] });
      var b = body();
      /* new cart lines / upsell re-init / upsell tab switch (Men | Women | Juniors) */
      if (b) new MutationObserver(function () { bindBody(); schedule(); }).observe(b, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "hidden"] });
      /* note popup opening / closing */
      var f = footer();
      if (f) new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].target !== btn) { schedule(); return; } /* ignore the cue's own class changes */
        }
      }).observe(f, { subtree: true, attributes: true, attributeFilter: ["class"] });
    }
    window.addEventListener("resize", schedule);

    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      var ev = MinimogTheme.pubSubEvents;
      if (ev.openCartDrawer) MinimogEvents.subscribe(ev.openCartDrawer, function () { setTimeout(schedule, 350); });
      if (ev.cartUpdate) MinimogEvents.subscribe(ev.cartUpdate, function () { setTimeout(schedule, 300); });
    }
    /* images inside the drawer change the layout after they load */
    d.addEventListener("load", schedule, true);
    schedule();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
